import React from 'react'
import PropTypes from 'prop-types'
import { keyBy } from 'lodash'
import { CommentListItem } from './CommentListItem'
import { Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Box } from '@chakra-ui/react'
import CustomLink from '../../../ui/CustomLink'

export const CommentList = ({ comments, onReply }) => {
  const handleReply = (evt, commentId) => {
    evt.preventDefault()
    evt.stopPropagation()
    onReply(commentId)
  }

  const commentsByKey = keyBy(comments, 'id')
  const rootComments = comments?.filter(comment => comment && !comment.parentId)

  return (
    <>
      {rootComments?.map((comment, index) => (
        <CommentListWithReplies
          key={comment.id}
          onReply={handleReply}
          user={comment.user}
          updated={comment.updated}
          text={comment.text}
          index={index}
          replies={comment.replies}
          id={comment.id}
        >
          {comment.replies?.map(
            (replyId, index) =>
              commentsByKey[replyId] && (
                <CommentListItem
                  key={index}
                  commentId={replyId}
                  commentText={commentsByKey[replyId].text}
                  user={commentsByKey[replyId].user}
                  updated={commentsByKey[replyId].updated}
                  parentId={commentsByKey[replyId].parentId}
                />
              ),
          )}
        </CommentListWithReplies>
      ))}
    </>
  )
}

const CommentListWithReplies = React.memo(
  ({ onReply, user, text, updated, id, index, replies, children }) => {
    return (
      <Box
        borderTop="1px solid"
        borderColor="brand.gray"
        cursor="pointer"
      >
        <CommentListItem
          index={index}
          user={user}
          commentText={text}
          updated={updated}
          commentId={id}
          data-test-id="comment-item"
        />
        <ReplyListContainer
          onReply={onReply}
          replies={replies}
          id={id}
        >
          {children}
        </ReplyListContainer>
      </Box>
    )
  },
)

const ReplyListContainer = React.memo(({ onReply, replies, id, children }) => {
  if (!replies || replies.length === 0) {
    return (
      <Box p={'0 16px 16px 16px'}>
        <CustomLink onClick={e => onReply(e, id)}>Reply</CustomLink>
      </Box>
    )
  }
  return (
    <Accordion
      allowToggle
      pr={0}
      borderColor="transparent"
    >
      <AccordionItem>
        <AccordionButton>
          <CustomLink onClick={e => onReply(e, id)}>
            Replies {replies.length ? `(${replies.length})` : ''}
          </CustomLink>
          <AccordionIcon
            fontSize="14px"
            color="brand.orange"
          />
        </AccordionButton>
        <AccordionPanel pr={0}>{children}</AccordionPanel>
      </AccordionItem>
    </Accordion>
  )
})

CommentList.propTypes = {
  comments: PropTypes.any,
  onReply: PropTypes.func,
}
